import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbtack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconThumbtack"><Path d="M12 15.25H4.75V12.5L5.12653 12.1235C6.48616 10.7638 7.25 8.91977 7.25 6.99695V5.75C7.25 4.09315 8.59315 2.75 10.25 2.75H13.75C15.4069 2.75 16.75 4.09315 16.75 5.75V6.99695C16.75 8.91977 17.5138 10.7638 18.8735 12.1235L19.25 12.5V15.25H12ZM12 15.25V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconThumbtack;
